import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './sass/index.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './contexts/auth-context';
import { ServiceProvider } from './contexts/service';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
/*root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);*/
root.render(

  <AuthProvider>
    <ServiceProvider>

      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ServiceProvider>
  </AuthProvider>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
